import React, { useEffect } from "react";

import analytics from "services/analytics";
import { useAppSelector } from "store/hooks";

const AnalyticsManager: React.FC = () => {
  const user = useAppSelector((state) => state.user.user);
  const subscription = useAppSelector((state) => state.subscription);

  useEffect(() => {
    if (user && user.userUid && subscription.subscription) {
      analytics().setUserInfo(user.userUid, {
        email: user.email,
        activeTrial: subscription.subscription?.isTrial || false,
        activePaidSubscriptionName: subscription.subscription?.paymentPlan.name,
      });
    }
  }, [user, subscription]);

  return null;
};

export default AnalyticsManager;
